import { USER_SUBSCRIPTIONS_FILTERS } from './types';

export enum SUBSCRIPTIONS {
    /**
     * @value Communities
     */
    COMMUNITIES = 'SOCIAL_PROFILE_COMMUNITIES',
    /**
     * @value Followed communities
     * @description Text displayed to show what communities the user is currently following
     */
    FOLLOWED_COMMUNITIES = 'SUBSCRIPTIONS.FOLLOWED_COMMUNITIES',
    /**
     * @value Followed content
     * @description Text displayed to show what pieces of content the user is currently following
     */
    FOLLOWED_CONTENT = 'SUBSCRIPTIONS.FOLLOWED_CONTENT',
    /**
     * @value Followed interests
     * @description Text displayed to show what interests the user is following.
     */
    FOLLOWED_INTERESTS = 'SUBSCRIPTIONS.FOLLOWED_INTERESTS',
    /**
     * @value Followed people
     * @description Text displayed to show what users the use is following.
     */
    FOLLOWED_PEOPLE = 'SUBSCRIPTIONS.FOLLOWED_PEOPLE',
    /**
     * @value Followers
     */
    FOLLOWERS = 'SOCIAL_PROFILE_FOLLOWERS',
    /**
     * @value Will appear in your activity feed
     */
    FOLLOW_HELP_TEXT = 'FRONT.FOLLOW_HELP_TEXT',
    /**
     * @value Interests
     */
    INTERESTS = 'SOCIAL_PROFILE_INTERESTS',
    /**
     * @value Receive a notification for all new activities
     */
    SUBSCRIBE_NOTIFICATIONS_HELP_TEXT = 'FRONT.SUBSCRIBE_NOTIFICATIONS_HELP_TEXT',
    /**
     * @value Will disappear from your activity feed
     */
    UNFOLLOW_HELP_TEXT = 'FRONT.UNFOLLOW_HELP_TEXT',
    /**
     * @value Stop receiving notifications
     */
    UNSUBSCRIBE_NOTIFICATIONS_HELP_TEXT = 'FRONT.UNSUBSCRIBE_NOTIFICATIONS_HELP_TEXT',
}

export const SubscriptionsTitleByType = {
    [USER_SUBSCRIPTIONS_FILTERS.communities]: SUBSCRIPTIONS.FOLLOWED_COMMUNITIES,
    [USER_SUBSCRIPTIONS_FILTERS.content]: SUBSCRIPTIONS.FOLLOWED_CONTENT,
    [USER_SUBSCRIPTIONS_FILTERS.people]: SUBSCRIPTIONS.FOLLOWED_PEOPLE,
    [USER_SUBSCRIPTIONS_FILTERS.interests]: SUBSCRIPTIONS.FOLLOWED_INTERESTS,
};
